<template>
  <resource-list-wrapper
    :class="[listPage && !totalItems && !noData && !loading ? 'wrapper-move-top list-wrapper' : 'list-wrapper']"
    :hidden="listPage && !totalItems && !noData && !loading"
    :title="$t('resources.airbyte_sources.title')">
    <template #default>
      <delete-resource-modal :resource-name="resourceName"></delete-resource-modal>
      <va-list
        :resource="resourceName"
        ref="list"
        :filter.sync="customFiltersValues"
        disable-export
        disable-create
        disable-bulk-delete
        @no-data="handleNoData"
        @update:total="handleTotalItems"
        @update:loading="handleLoading"
        :create-button-label="$t('generic.buttons.create')">
        <template #no-results>
          <div class="no-results">
            {{ $t("custom.no_data") }}
          </div>
        </template>
        <va-data-table :disable-clone="true" :fields="fields" class="va-table--selectable" disable-select>
          <template #[`cell.actions`]="{ item }">
            <DataListActions
              :actions="[
                { title: 'Delete', icon: 'mdi-trash-can-outline', function: deleteResource.bind(this, item) },
              ]"></DataListActions>
          </template>
        </va-data-table>
      </va-list>
    </template>
  </resource-list-wrapper>
</template>

<script>
  import ResourceListWrapper from "@/components/resourceWrappers/ResourceListWrapper";
  import DataListActions from "@/components/custom/DataListActions";
  import DeleteResourceModal from "@/components/resources/DeleteResourceModal";
  import definedAbility from "@/ability";

  export default {
    components: {
      ResourceListWrapper,
      DataListActions,
      DeleteResourceModal,
    },
    props: {
      resourceName: {
        type: String,
        default() {
          return this.$route.meta.resource;
        },
      },
      activeFilterOnload: {
        type: Object,
        default: () => ({}),
      },
      /**
       * True if component is used in VA-admin generated route for resource list;
       * False when used elsewhere (Single domain view for example).
       */
      listPage: {
        type: Boolean,
        default: true,
      },
      domainId: {
        type: String,
        default: "",
      },
    },
    data() {
      return {
        ability: definedAbility(),
        noData: false,
        loading: true,
        totalItems: 0,
        customFiltersValues: {},
        fields: [
          {
            source: "display",
            label: "Name",
            sortable: true,
            width: "50%",
          },
          {
            source: "type",
            sortable: true,
            width: "50%",
          },
        ],
      };
    },
    methods: {
      handleNoData(val) {
        this.noData = val;
      },
      handleLoading(val) {
        this.loading = val;
      },
      handleTotalItems(val) {
        this.totalItems = val;
      },
      async deleteResource(item) {
        this.$store.dispatch(`${this.resourceName}/displayDeleteModal`, {
          displayDeleteModal: true,
          items: [item],
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "@core/preset/preset/functions.scss";
  @import "@core/preset/preset/typography/index.scss";

  .logo-img {
    max-width: 36px;
    min-height: 36px;
    margin: 5px 0;
    border-radius: 50%;
  }

  .list-wrapper {
    margin-top: 16px;

    ::v-deep {
      .list__heading {
        .list__heading-title-wrapper {
          margin-bottom: 4px;
        }

        h1 {
          @include heading-4();
        }
      }

      .v-data-iterator {
        margin-top: 0;
        box-shadow: none !important;

        .v-data-table {
          margin-top: 12px;

          table {
            min-width: unset;
          }
        }

        .v-toolbar {
          display: none;
        }

        div {
          @include text-body-2();
        }
      }
    }
  }
</style>
